import React from 'react';
import ScrollToTopIcon from '../../../../components/ScrollToTopIcon/scrollToTopIcon';
import Footer from '../footer';
import LandingHeader from '../landingHeader';
import '../landingPage.scss';
import Policy from '../Terms/policy';


const PrivacyAndPolicy = () => {

    return (
        <div className='wrapper' >
            <div className='container'>
                <LandingHeader referances={{}} />
                <Policy />
                <Footer referances={{}} />
            </div>
            <ScrollToTopIcon />
        </div>
    )
}

export default PrivacyAndPolicy;